import { render } from "./add-kpi.vue?vue&type=template&id=ad76a576"
import script from "./add-kpi.vue?vue&type=script&lang=js"
export * from "./add-kpi.vue?vue&type=script&lang=js"
script.render = render

export default script